export default function GenericTab(props: any): JSX.Element {
    return <>
        <div className={props.className + " grid mt-10 "+
            (props.noMargin ? " " : " md:mx-20 ")}>
            {props.children}
        </div>
    </>
}